export const countryCodes = [
  { code: "+91", country: "IN", flag: "🇮🇳", length: 10, name: "India" },
  // { code: "+1", country: "US", flag: "🇺🇸", length: 10 },
  {
    code: "+44",
    country: "UK",
    flag: "🇬🇧",
    length: 10,
    name: "United Kingdom",
  },
  // { code: "+86", country: "CN", flag: "🇨🇳", length: 11 },
];

export const countryCodeOptions = countryCodes.map((item) => ({
  label: `${item.flag} ${item.code} (${item.country})`,
  value: item.code,
}));
